
  var _styles = {
  "top-fix-bar": {
    "width": "9.36rem",
    "height": "1.38667rem",
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgba(0,0,0,0.8)",
    "marginTop": 0,
    "marginRight": "auto",
    "marginBottom": 0,
    "marginLeft": "auto",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.24rem",
    "paddingRight": 0,
    "paddingBottom": "0.24rem",
    "paddingLeft": 0
  },
  "top-fix-bar-text": {
    "width": "4.28rem",
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem",
    "textAlign": "left",
    "marginLeft": "0.2rem"
  },
  "top-fix-bar-anchor": {
    "width": "1.81333rem",
    "height": "0.56rem",
    "borderRadius": "0.56rem",
    "backgroundColor": "rgb(255,242,0)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginLeft": "1.04rem"
  },
  "top-fix-bar-anchor-text": {
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.29333rem",
    "lineHeight": "0.56rem",
    "textAlign": "left"
  },
  "top-fix-bar-anchor-close": {
    "width": "0.64rem",
    "height": "0.64rem",
    "marginLeft": "0.05333rem"
  }
};



  module.exports = _styles;
  